import { ISlider } from '../IComponents.js';

/**
 * BasicSlider - HTML range input as a slider (horizontal or vertical)
 */
export class BasicSlider extends ISlider {
    constructor(container, options) {
        super(container, options);
        this.value = options.value ?? options.min ?? 0;
        this._create();
    }

    _create() {
        const { min = 0, max = 100, value, label, step, vertical = false } = this.options;

        this.element = document.createElement('div');
        this.element.className = vertical ? 'fader-container' : 'slider-container';

        // Input range
        this.input = document.createElement('input');
        this.input.type = 'range';
        this.input.min = min;
        this.input.max = max;
        this.input.value = value ?? min;
        if (step) this.input.step = step;

        if (vertical) {
            this.input.className = 'vertical-fader';
        }

        // Label
        if (label) {
            this.labelEl = document.createElement('span');
            this.labelEl.className = 'slider-label';
            this.labelEl.textContent = label;
        }

        // Event listener
        this.input.addEventListener('input', (e) => {
            this.value = parseFloat(e.target.value);
            this._emitChange(this.value);
        });

        // Assemble
        if (this.labelEl && !vertical) this.element.appendChild(this.labelEl);
        this.element.appendChild(this.input);
        if (this.labelEl && vertical) this.element.appendChild(this.labelEl);

        this.container.appendChild(this.element);
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = value;
        this.input.value = value;
    }
}
